import { render, staticRenderFns } from "./salesByDistributorBySKU.vue?vue&type=template&id=bc20b0c4&"
import script from "./salesByDistributorBySKU.vue?vue&type=script&lang=js&"
export * from "./salesByDistributorBySKU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports